export default __webpack_public_path__ + "static/media/logo1.c36fdd19.svg";